import { useTranslation } from 'react-i18next';

import { CurrencyType, StaminaType } from '../../../../constants/currencies';
import { SVGIconType } from '../../../../constants/svgIcon';
import { BalanceType } from '../../../../models/Base';
import { QuickCreateGameMode } from '../../../../models/DraftStore';
import {
  CurrencyNode,
  GeneralModal,
  GeneralModalNoButtonVariant,
  GeneralModalYesButtonVariant,
  SvgIcon,
} from '../../../Molecules';

import styles from './TranslateAnswerModal.module.css';

type TranslateAnswerModalProps = {
  type: QuickCreateGameMode;
  language: string;
  currencyType: CurrencyType;
  fee: number;
  isDisableBackground: boolean;
  onPrimary: () => void;
  onPressCancel: () => void;
  onClickLanguage: () => void;
};

export const TranslateAnswerModal = (props: TranslateAnswerModalProps) => {
  const {
    type,
    language,
    currencyType,
    fee,
    isDisableBackground,
    onPrimary,
    onPressCancel,
    onClickLanguage,
  } = props;
  const { t } = useTranslation();

  return (
    <GeneralModal
      isYesNo={true}
      onYes={onPrimary}
      onClose={onPressCancel}
      buttonSetting={{
        noText: t('No'),
        noVariant: GeneralModalNoButtonVariant.Gray,
        yesVariant: GeneralModalYesButtonVariant.Cyan,
        yesText: t('OK'),
      }}
      currencies={[StaminaType.CreationStamina, BalanceType.Token]}
      isDisableBackground={isDisableBackground}
      isDisableWidthAndPadding={true}
    >
      <div className={styles.translate}>
        <div className={styles.centerContainer}>
          <SvgIcon
            name={SVGIconType.Translation}
            className={styles.titleIcon}
          />
          <p className={styles.textTitle}>{t('Translation of Answer')}</p>

          <div className={styles.buttonContainer} onClick={onClickLanguage}>
            <div className={styles.languageSelector}>
              <SvgIcon
                name={SVGIconType.LanguageQ}
                width={28}
                height={28}
                color={'white'}
              />
              <span className={styles.language}>{t(language)}</span>
              <SvgIcon
                name={SVGIconType.Triangle}
                width={16}
                height={16}
                color={'white'}
                style={{ marginRight: '4px' }}
              />
            </div>
          </div>

          <div className={styles.warningText}>
            {t('Existing text will be replaced.')}
            {type !== QuickCreateGameMode.QuickMemory ? (
              <div>
                {t(
                  'Text-to-Speech will be changed to the translated question.',
                )}
              </div>
            ) : null}
          </div>

          <p className={styles.textNormal}>
            {t('Are you sure you want to translate the answer?')}
          </p>

          <CurrencyNode currencyType={currencyType} amount={fee} />
        </div>
      </div>
    </GeneralModal>
  );
};
